import {HttpResponseDto, InventoryControllerService, ProductDto} from '../../@api';
import {Component, Inject, OnInit} from '@angular/core';
import {AbstractQuote} from '../../common/quote/abstract-quote';
import {DOCUMENT} from '@angular/common';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {NavigationEnd, Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';
import {filter} from 'rxjs/operators';

const selector: string = 'batteries';

@Component({
    selector: selector,
    templateUrl: './batteries.component.html',
    styleUrls: ['./../retail.component.scss']
})
export class BatteriesComponent extends AbstractQuote implements OnInit {

    activated: boolean;

    constructor(@Inject(DOCUMENT) public override document: Document,
                protected override state: StatePersistenceService,
                protected override browser: BrowserStorageService,
                protected override router: Router,
                protected override breadcrumbService: BreadcrumbService,
                private inventoryControllerService: InventoryControllerService) {
        super(document, state, browser, router, breadcrumbService);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any): void => {
            const url: string = event.url;
            this.activated = (url.substring(url.lastIndexOf('/') + 1) === selector);
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.inventoryControllerService.findAllProductsByCategory('Batteries').subscribe((response: HttpResponseDto): void => {
            let record: any = { products: [] };
            let batteries: ProductDto[] = JSON.parse(response.data);

            this.data = [];
            batteries.forEach((battery: ProductDto): void => {
                if (record.products.length < 3) {
                    record.products.push(battery);
                } else {
                    this.data.push(Object.assign({}, record));
                    record = { products: [] };
                    record.products.push(battery);
                }
            });
            this.data.push(Object.assign({}, record));
        }, error => {
            console.log(error);
        });
    }
}
